import { render, staticRenderFns } from "./Nuovo.vue?vue&type=template&id=44692fae"
import script from "./Nuovo.vue?vue&type=script&lang=js"
export * from "./Nuovo.vue?vue&type=script&lang=js"
import style0 from "./Nuovo.vue?vue&type=style&index=0&id=44692fae&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports